import { CalendarDays, ArrowUpRight } from "lucide-react";

export default function Workshops() {
  return (
    <section
      id="workshops"
      data-testid="workshops-section"
      className="relative py-24 lg:py-32 bg-cream"
    >
      <div className="mx-auto max-w-6xl px-6 lg:px-10">
        <div className="relative overflow-hidden rounded-[40px] bg-white border border-sage/30 aw-shadow-lg">
          <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-[#8A9A86]/25 blur-3xl" />
          <div className="absolute -bottom-24 -left-24 h-72 w-72 rounded-full bg-[#D8B4A0]/30 blur-3xl" />

          <div className="relative p-10 lg:p-16 grid lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-7">
              <p className="text-xs tracking-eyebrow uppercase text-sage mb-5 flex items-center gap-3">
                <CalendarDays size={14} className="text-clay" />
                Workshops &amp; Gatherings
              </p>
              <h2
                data-testid="workshops-headline"
                className="font-serif-display text-forest text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight"
              >
                Seasonal circles,
                <br />
                <span className="italic">announced soon.</span>
              </h2>
              <p className="mt-6 max-w-xl text-forest-soft text-lg leading-relaxed">
                Tammy hosts intimate workshops on self-love, affirmations, and
                mind–body healing throughout the year. Dates are shared first
                on alignwithtammy.com — and with our quiet little community
                below.
              </p>

              <div className="mt-10 flex flex-wrap items-center gap-4">
                <a
                  href="https://www.alignwithtammy.com"
                  target="_blank"
                  rel="noreferrer"
                  data-testid="workshops-external-link"
                  className="aw-btn-primary"
                >
                  Visit alignwithtammy.com
                  <ArrowUpRight size={16} />
                </a>
                <a
                  href="#connect"
                  data-testid="workshops-notify-cta"
                  className="aw-btn-ghost"
                >
                  Notify me of dates
                </a>
              </div>
            </div>

            <div className="lg:col-span-5">
              <div className="rounded-3xl bg-[#EAECE8] p-8 border border-sage/30">
                <p className="text-xs tracking-eyebrow uppercase text-sage">
                  Next gathering
                </p>
                <p className="mt-3 font-serif-display text-3xl text-forest leading-tight">
                  Totality of Possibilities
                </p>
                <p className="mt-2 text-forest-soft text-sm leading-relaxed">
                  A 1-hour presentation presented at the Sakred Circles
                  Gathering in Cameron Lake, BC.
                </p>
                <div className="mt-6 flex items-center justify-between text-sm">
                  <div>
                    <p className="text-[11px] tracking-eyebrow uppercase text-sage">
                      Date
                    </p>
                    <p className="mt-1 text-forest font-serif-display text-lg">
                      August 7–9, 2026
                    </p>
                  </div>
                  <div className="text-right">
                    <p className="text-[11px] tracking-eyebrow uppercase text-sage">
                      Format
                    </p>
                    <p className="mt-1 text-forest font-serif-display text-lg">
                      In person
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
